import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import LayoutMain from "../Layout";
import Login from "../pages/Auth/Login";
import ForgotPassword from "../pages/Auth/ForgotPassword";
import Users from "../pages/UserManagement/Users";
import AddUser from "../pages/UserManagement/Users/AddUser";
import EditUser from "../pages/UserManagement/Users/EditUser";
import UserRoles from "../pages/UserManagement/UserRoles";
import AddRoles from "../pages/UserManagement/UserRoles/AddRoles";
import EditRoles from "../pages/UserManagement/UserRoles/EditRoles";
import UserPermission from "../pages/UserManagement/UserRoles/UserPermission";
import { GetToken } from "../utils";
import { hasAccess, homePath } from "../utils/Permission";
import { useAccess } from "../hooks/usePermission";
import Organizations from "../pages/Organizations";
import OrganizationForm from "../pages/Organizations/OrganizationForm";
import OrganizationDetails from "../pages/Organizations/OrganizationDetails";
import Settings from "../pages/Settings";

import AddTicket from "../pages/TicketManagement/addTicket";
import EditTicket from "../pages/TicketManagement/EditTicket";
import Ticket from "../pages/TicketManagement";

import HipDashboard from "../pages/HIP";
import HiuDashboard from "../pages/Boxes/BoxesHiu";
import AbhaCreated from "../pages/HIP/AbhaCreated";
import HipLog from "../pages/HIP/HipLog";
import HipDataRequestReceived from "../pages/HIP/HipDataRequestReceived";
import HipContestGrant from "../pages/HIP/HipContestGrant";
import HipUserInisiated from "../pages/HIP/HipUserInisiated";
import ConsentArtifactRequested from "../pages/HIU/ConsentArtifactRequested";
import ConsentGrant from "../pages/HIU/ConsentGrant";
import ConsentArtifactDetails from "../pages/HIU/ConsentArtifactDetails";
import HelathInformationRequested from "../pages/HIU/HelathInformationRequested";
import AskReport from "../pages/HIU/HelathInformationRequested/ReportDetail";
import LinkedLog from "../pages/HIP/LinkedLog";
import DataShared from "../pages/HIP/DataShared";
import DataPending from "../pages/HIP/DataPending";
import DataReceived from "../pages/HIU/DataReceived";
import DataRequestPending from "../pages/HIU/DataRequestPending";
import ReportList from "../pages/HIP/ReportList/report";
import NoPermission from "../pages/NoPermission";
import HIPLinkedCareContexts from "../pages/HIP/HIPLinkedCareContexts/inedx";
import AuditLogs from "../pages/HIP/AuditLogs/index";
import { ToastContainer } from "react-toastify";
// import ConsentApproved from '../pages/HIP/ConsentApproved';
// import ReportPushed from '../pages/HIP/ReportPushed';
// import ReportRequested from '../pages/HIP/ReportRequested';
// import ReportReceived from '../pages/HIP/ReportRecieved';
// import ReportDetail from '../pages/HIP/AskforReport/ReportDetail';
// import HipAuthConfirm from '../pages/HIP/HipAuthConfirm';
function RequireAuth({ children }) {
  const token = GetToken();
  return token ? children : <Navigate to="/login" replace />;
}
// Page needs View on any of `modules`
function RequireAccess({ modules, children }) {
  const access = useAccess();
  if (!access.loaded) return null;
  return hasAccess(access, modules) ? children : <Navigate to="/no-permission" replace />;
}
// "/" opens the first page the role can see
function HomeRedirect() {
  const access = useAccess();
  if (!access.loaded) return null;
  return <Navigate to={homePath(access)} replace />;
}
function AlreadyLogin({ children }) {
  const token = GetToken();
  return token ? <Navigate to="/" replace /> : children;
}

const PageRoutes = () => {
  return (
    <div className="main_wrapper">
      <ToastContainer />
      <Routes>
        <Route
          path="/forgot-password"
          element={
            <AlreadyLogin>
              {" "}
              <ForgotPassword />
            </AlreadyLogin>
          }
        />
        <Route
          path="/login"
          element={
            <AlreadyLogin>
              <Login />
            </AlreadyLogin>
          }
        />
        <Route
          element={
            <RequireAuth>
              {" "}
              <LayoutMain />
            </RequireAuth>
          }
        >
          <Route path="/" element={<HomeRedirect />} />

          <Route path="/users" element={<Users />} />
          <Route path="/user/list" element={<Users />} />
          <Route path="/user/add" element={<AddUser />} />
          <Route path="/user/edit/:userId" element={<EditUser />} />

          <Route path="/roles" element={<UserRoles />} />
          <Route path="/role/list" element={<UserRoles />} />
          <Route path="/role/add" element={<AddRoles />} />
          <Route path="/role/edit/:roleId" element={<EditRoles />} />
          <Route
            path="/role/user-permission/:roleId"
            element={<UserPermission />}
          />
          <Route path="/settings" element={<Settings />} />

          {/* Everyone sees organizations; the server limits which ones */}
          <Route path="/organizations" element={<Organizations />} />
          <Route path="/organization/add" element={<RequireAccess modules="Users Management"><OrganizationForm /></RequireAccess>} />
          <Route path="/organization/edit/:id" element={<RequireAccess modules="Users Management"><OrganizationForm /></RequireAccess>} />
          <Route path="/organization/view/:id" element={<OrganizationDetails />} />
          {/* Facilities now live inside an organization; old links go to Organizations */}
          <Route path="/facilities" element={<Navigate to="/organizations" replace />} />

          <Route path="/ticket-management" element={<Ticket />} />
          <Route path="/ticket-management/add" element={<AddTicket />} />
          <Route path="/ticket-management/edit/:Id" element={<EditTicket />} />
          <Route path="/hip-dashboard" element={<HipDashboard />} />
          <Route path="/hiu-dashboard" element={<HiuDashboard />} />

          <Route path="/abha-linked" element={<AbhaCreated />} />
          <Route path="/abha-linked-log" element={<LinkedLog />} />
          <Route path="/report-list" element={<ReportList />} />

          <Route path="/hip-log" element={<HipLog />} />
          <Route path="/hip-user-inisiated" element={<HipUserInisiated />} />
          <Route path="/hip-consent-grant" element={<HipContestGrant />} />
          <Route
            path="/hip-data-request-received"
            element={<HipDataRequestReceived />}
          />
          <Route path="/hip/data-shared" element={<DataShared />} />
          <Route
            path="/hip/linked-care-contexts"
            element={<HIPLinkedCareContexts />}
          />
          <Route path="/hip-data-request-pending" element={<DataPending />} />

          <Route
            path="/hiu-consent-artifact-requested"
            element={<ConsentArtifactRequested />}
          />
          <Route path="/hiu-consent-grant" element={<ConsentGrant />} />
          <Route
            path="/hiu-consent-artifact-details"
            element={<ConsentArtifactDetails />}
          />
          <Route
            path="/hiu-helath-information-requested"
            element={<HelathInformationRequested />}
          />
          <Route
            path="/PatientReport"
            element={<HelathInformationRequested />}
          />
          <Route path="/hip/report-detail" element={<AskReport />} />

          <Route path="/hiu/data-received" element={<DataReceived />} />
          <Route
            path="/hiu/data-request-pending"
            element={<DataRequestPending />}
          />

          <Route path="/audit-logs" element={<RequireAccess modules={["HIP Dashboard", "HIU Dashboard"]}><AuditLogs /></RequireAccess>} />

          <Route path="hip/ask-report" element={<AskReport />} />
          <Route path="/no-permission" element={<NoPermission />} />
        </Route>
      </Routes>
    </div>
  );
};

export default PageRoutes;
